// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import fileDropTargetDecorator from '../../../../../components/tools/files/fileDropTargetDecorator';
import AvatarPicker from './AvatarPicker';

// Actions
import { updateCurrentUser, uploadCurrentUserAvatar } from '../../../../../user/currentUserActions';
import { cleanElementAttachment } from '../../../../../element/attachments/attachmentActions';

// File drop functionality
const AvatarPickerWithFileDrop = fileDropTargetDecorator(AvatarPicker);

const mapStateToProps = createStructuredSelector({
    attachment: (state, ownProps) => state.getIn(['app', 'attachments', ownProps.user.get('_id')]),
});

const mapDispatchToProps = (dispatch) => ({
    dispatchCleanUserAttachment: (id) => dispatch(cleanElementAttachment({ id })),
    dispatchUploadCurrentUserAvatar: (userId, file) => dispatch(uploadCurrentUserAvatar({ userId, file })),
    dispatchRemoveCurrentUserAvatar: () => dispatch(updateCurrentUser({ changes: { image: null } })),
});

@connect(mapStateToProps, mapDispatchToProps)
class AvatarPickerContainer extends React.Component {
    cleanUserAttachment = () => {
        const { dispatchCleanUserAttachment, user } = this.props;
        dispatchCleanUserAttachment(user.get('_id'));
    };

    uploadFile = (imageFile) => {
        const { user, dispatchUploadCurrentUserAvatar } = this.props;
        dispatchUploadCurrentUserAvatar(user.get('_id'), imageFile);
    };

    render() {
        return (
            <AvatarPickerWithFileDrop
                {...this.props}
                uploadFile={this.uploadFile}
                cleanUserAttachment={this.cleanUserAttachment}
            />
        );
    }
}

AvatarPickerContainer.propTypes = {
    user: PropTypes.object.isRequired,
    attachment: PropTypes.object,
    uploadUserAvatar: PropTypes.func,
    dispatchUploadCurrentUserAvatar: PropTypes.func,
    dispatchCleanUserAttachment: PropTypes.func,
};

export default AvatarPickerContainer;
